import axios, { AxiosInstance } from 'axios'
import {createAuthProvider} from '../providers/auth'
import {ContractEventPayload} from '../types/contract-event'

type Constructor = {
  url: string
  authToken: string
}

class ContractService {
  private api: AxiosInstance

  constructor(param: Constructor) {
    this.api = axios.create({
      baseURL: param.url,
      headers: {
        authorization: param.authToken
      }
    })
  }

  async getSkusFromContract(id: number): Promise<any> {
    const { data } = await this.api.get(`/contracts/${id}/current-skus`)

    return data
  }

  async getLegal(id: number): Promise<any> {
    const { data } = await this.api.get(`/contracts/${id}/legal`)

    return data
  }

  async createContractEvent(payload: ContractEventPayload): Promise<number> {
    const { status } = await this.api.post('/contract-events', payload)

    return status
  }
}

export function createContractService() {
  const authProvider = createAuthProvider()

  if (!process.env.REACT_APP_CONTRACT_API_URL) {
    throw new Error('EnvNotFound')
  }

  return new ContractService({
    url: process.env.REACT_APP_CONTRACT_API_URL,
    authToken: `Bearer ${authProvider.getToken()}`
  })
}
